import React, {useState,useEffect}from 'react';
import OtherBanner from '../components/OtherBanner';
import ImageWithText from '../components/ImageWithText';
import OurValue from '../components/OurValue';
import Milestone from '../components/Milestone';
import QuickPoint from '../components/QuickPoint';
import DownloadApp from '../components/DownloadApp';

import aboutImg from '../assets/img/about-img1.png';
import AboutBanner from '../assets/img/about-banner.png';
import webPortalServices from '../../services/webPortal.services';

const About = () => {
    const [pageContets, setPageContets] = useState([]);

  useEffect(()=>{
   webPortalServices.customizedData().then((res)=>{
    setPageContets(res.data.webNavMenuList)
  });
 
},[])

const filterAbout = pageContets.filter(item => item.status === 1 && item.pageUrl ==='about');
    return (
        <>
        <OtherBanner 
            image={filterAbout[0]?.bannerImg ? filterAbout[0]?.bannerImg : AboutBanner}
            title={filterAbout[0]?.bannerTitle ? filterAbout[0]?.bannerTitle : "Testigo"}
            text={filterAbout[0]?.bannerText ? filterAbout[0]?.bannerText : "Mobile Medical Diagnostics are an Irish owned and operated company that provide a high quality service to clients in to primary care centres, nursing homes hospitals and healthcare providers nationwide"}
        />
        <ImageWithText 
            class="aboutPage_about"
            image={aboutImg}
            smallHeading= {`${filterAbout[0]?.sectionOneSmallHeadin ? filterAbout[0]?.sectionOneSmallHeadin:'About Us'}`} 
            heading={`${filterAbout[0]?.sectionOneHeading ?filterAbout[0]?.sectionOneHeading:'About Testigo On Demand Mobile X-Ray Solutions'}`}
            para={`${filterAbout[0]?.sectionOneParagraph ? filterAbout[0]?.sectionOneParagraph:'We are the only fully licensed mobile radiology service in Ireland. Our mantra is moving equipment not patients and our mission is to bring quality care and diagnostics to communities in a clinically compliant manner. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries'}`}
        />
        <OurValue 
          pageName="about"
        />
        <Milestone />
        <QuickPoint
            text="Moving equipment not patients. For more information call us"
            phoneNo="087 056 4412"
         />
        <DownloadApp /> 
        </>
    );
};

export default About;